import React, { useState, useCallback } from 'react';

import { App, Table, Tooltip, Typography } from 'antd';
import type { ColumnsType } from 'antd/es/table';

import ActionCollapse from 'v2/components/Shared/QuickView/ActionCollapse';
import type { ShoppingDelivery } from 'v2/interfaces/shopping';
import { dateService } from 'v2/services/date';
import shoppingService from 'v2/services/shopping/subscription';

import { Icon } from '@eduzz/ui-antd-theme';

import { TABLE_STATUS_BASE, getStatusColor } from '../statusColors';

interface PaymentHistoryProps {
  delivery: ShoppingDelivery;
}

export const PaymentHistory = ({ delivery }: PaymentHistoryProps) => {
  const { message } = App.useApp();
  const [loadingHistory, setLoadingDocument] = useState<boolean>(false);
  const [history, setHistory] = useState<any[]>([]);

  const handleClickHistory = useCallback(
    (subscriptionId: number) => {
      setLoadingDocument(true);
      shoppingService.loadSubscriptionHistory(subscriptionId).subscribe(
        res => {
          setHistory(res.data);
          setLoadingDocument(false);
        },
        () => {
          setLoadingDocument(false);
          message.error('Não foi possível carregar o histórico de pagamento.');
        }
      );
    },
    [message]
  );

  const columns: ColumnsType<any> = [
    {
      title: '',
      key: 'status',
      width: 20,
      render: (_, record) => (
        <Tooltip placement='top' title={record.payment_status.name}>
          <div className={`${TABLE_STATUS_BASE} ${getStatusColor(record.payment_status.alias)}`} />
        </Tooltip>
      )
    },
    {
      title: 'Fatura',
      key: 'id',
      dataIndex: 'id',
      render: value => <Typography.Text type='secondary'>{value}</Typography.Text>
    },
    {
      title: 'Pagamento',
      key: 'received_at',
      render: (_, record) => (
        <Typography.Text type='secondary'>
          {record.received_at ? dateService.dateToString(new Date(record.received_at), 'dd/MM/yyyy') : '-'}
        </Typography.Text>
      )
    },
    {
      title: 'Valor',
      key: 'amount',
      align: 'right',
      render: (_, record) => (
        <Typography.Text type='secondary'>
          {record.amount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
        </Typography.Text>
      )
    }
  ];

  return (
    <ActionCollapse
      title='Histórico de Pagamento'
      icon={<Icon.History size={16} />}
      onExpand={expanded => {
        if (expanded) {
          handleClickHistory(delivery.subscription_id);
        }
      }}
    >
      <Table
        size='small'
        columns={columns}
        dataSource={history}
        rowKey='id'
        loading={loadingHistory}
        pagination={false}
      />
    </ActionCollapse>
  );
};
